import { Colors } from '@dew21/ui';
import React, { FC } from 'react';
import styled from 'styled-components';
import { NotFoundIcon } from './NotFoundIcon';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;


const Heading = styled.div`
  color: ${Colors.primary};
  text-transform: uppercase;
  margin-bottom: 1.5rem;
  font-size: 1.875rem;
`;

const Text = styled.div`
  color: ${Colors.grayDark};
  margin-bottom: .5rem;
  font-size: 1.25rem;
`;

const SubText = styled.div`
  color: ${Colors.gray};
  margin-bottom: 1.5rem;  
  font-size: 1rem;
`;

export const NotFound: FC = (props) => {
  return <Wrapper>
    <Heading>ERROR 404</Heading>
    <Text>Diese Seite ist leider nicht verfügbar.</Text>
    <SubText>Die angefragte Ressource konnte nicht gefunden werden.</SubText>
    <NotFoundIcon/>
  </Wrapper>;
};
